import { render } from "./GroupDetailfull.vue?vue&type=template&id=f4a15136&scoped=true"
import script from "./GroupDetailfull.vue?vue&type=script&lang=js"
export * from "./GroupDetailfull.vue?vue&type=script&lang=js"

import "./GroupDetailfull.vue?vue&type=style&index=0&id=f4a15136&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a15136"]])

export default __exports__